module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iVzYb"))).then(() => parcelRequire('cvs7o'));